<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  totalCount: {
    type: Number,
    default: 0,
  },
  exceedingCount: {
    type: Number,
    default: 0,
  },
  thresholdMinutes: {
    type: Number,
    default: 10,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
    <div
      class="flex flex-col gap-1 p-4 border rounded-lg bg-n-solid-2 border-n-weak"
    >
      <span class="text-sm font-medium text-n-slate-11">
        {{ t('COMPLIANCE.METRICS.WAITING_CONVERSATIONS') }}
      </span>
      <span v-if="!isLoading" class="text-2xl font-semibold text-n-slate-12">
        {{ totalCount }}
      </span>
      <span v-else class="w-16 h-8 rounded bg-n-alpha-2 animate-pulse" />
    </div>

    <div
      class="flex flex-col gap-1 p-4 border rounded-lg bg-n-solid-2 border-n-weak"
    >
      <span class="text-sm font-medium text-n-slate-11">
        {{ t('COMPLIANCE.METRICS.EXCEEDING_THRESHOLD') }}
      </span>
      <span
        v-if="!isLoading"
        class="text-2xl font-semibold"
        :class="exceedingCount > 0 ? 'text-r-600' : 'text-n-slate-12'"
      >
        {{ exceedingCount }}
      </span>
      <span v-else class="w-16 h-8 rounded bg-n-alpha-2 animate-pulse" />
    </div>

    <div
      class="flex flex-col gap-1 p-4 border rounded-lg bg-n-solid-2 border-n-weak"
    >
      <span class="text-sm font-medium text-n-slate-11">
        {{ t('COMPLIANCE.METRICS.THRESHOLD') }}
      </span>
      <span v-if="!isLoading" class="text-2xl font-semibold text-n-slate-12">
        {{ thresholdMinutes }} {{ t('COMPLIANCE.MINUTES') }}
      </span>
      <span v-else class="w-16 h-8 rounded bg-n-alpha-2 animate-pulse" />
    </div>
  </div>
</template>
